import { Item, ItemActions, ItemDescription, ItemHeader, ItemTitle, ScrollArea } from '@ibsys/kit';
import { XIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SCROLL_AREA_VIEWPORT_BLOCK } from '@/shared/lib';
import { IconButton } from '@/shared/ui';
import { getRecordFileKey } from '../model/recordFiles';

/** Байт в мегабайте: размер файла показывается в тех же единицах, что и предел загрузки */
const BYTES_IN_MB = 1024 * 1024;

type Props = {
  files: File[];
  /** Убрать файл из порции по его ключу */
  onRemove: (fileKey: string) => void;
  disabled: boolean;
};

/** Файлы, принятые областью загрузки и ждущие добавления */
export const RecordFilesList: FC<Props> = ({ files, onRemove, disabled }) => {
  const { t } = useTranslation(['records']);

  if (files.length === 0) return null;

  return (
    <ScrollArea orientation="vertical" className={SCROLL_AREA_VIEWPORT_BLOCK} viewPortProps={{ className: 'max-h-40' }}>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 xl:grid-cols-3">
        {files.map((file) => {
          const fileKey = getRecordFileKey(file);
          return (
            <Item key={fileKey} variant="outline" size="sm" className="min-w-0">
              <ItemHeader className="min-w-0">
                <ItemTitle className="min-w-0 wrap-break-word">{file.name}</ItemTitle>
                <ItemActions className="shrink-0">
                  <IconButton
                    size="icon"
                    icon={<XIcon />}
                    label={t('records:fileUpload.removeFile', { fileName: file.name })}
                    onClick={() => onRemove(fileKey)}
                    disabled={disabled}
                  />
                </ItemActions>
              </ItemHeader>
              <ItemDescription className="text-xs text-muted-foreground">
                {t('records:fileUpload.fileSize', { size: (file.size / BYTES_IN_MB).toFixed(2) })}
              </ItemDescription>
            </Item>
          );
        })}
      </div>
    </ScrollArea>
  );
};
